import type { DefaultOptionType } from 'antd/lib/select';
import {
  sortSkillsByName,
  type WorkerSkillType,
} from '@load-balancing/services';

export function buildSkillOptions(
  catalog: readonly WorkerSkillType[]
): { value: string; label: string }[] {
  return sortSkillsByName(catalog).map((skill) => ({
    value: skill.id,
    label: skill.name,
  }));
}

export function filterByLabel(input: string, option?: DefaultOptionType) {
  return String(option?.label ?? '')
    .toLowerCase()
    .includes(input.toLowerCase());
}
